import React, { useEffect, useState, useContext } from 'react'
import { message } from 'antd'
import PresentationDrawer from './presentationDrawer'
import GeneralTable from '../../../../components/Table'
import Utils from '../../../../utils/Utils'
import presentationSrc from './presentationSrc'
import PresentationAssignDrawer from './presentationAssignDrawer'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import Discounts from '../discountTabs/discountSrc'
import { Context } from '../../../../context'

function PresentationTab(props) {
  const [{ auth }] = useContext(Context)
  const [dataSource, setDataSource] = useState([])
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [nextPage, setNextPage] = useState('')
  const [assignData, setAssignData] = useState({})
  const [loading, setLoading] = useState(true)
  const [visible, setVisible] = useState(false)
  const [visibleAssign, setVisibleAssign] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [dataDiscounts, setDataDiscounts] = useState([])
  
  useEffect(() => {
    if (props.keyTab === '2') {
      loadData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.keyTab])

  const getDiscountsData = dataSrc => {
    if (dataSrc !== 'Too Many Attempts.') {
      let _dataSrc = dataSrc?.data || []
      
      return _dataSrc.map((d, i) => ({
        key: i,
        id: d.id,
        discount_level: d.discount_level,
        company_id: d.company_id
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const columns = [
    {
      title: 'Descripción',
      dataIndex: 'description', // Field that is goint to be rendered
      key: 'description',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Producto al que pertenece',
      dataIndex: 'product_name', // Field that is goint to be rendered
      key: 'product_name',
      render: text => <span>{text}</span>,
    },
    {
      title: '¿Es agrupación de la expresión mínima del producto?',
      dataIndex: 'is_grouping', // Field that is goint to be rendered
      key: 'is_grouping',
      render: text => <span>{text === 1 ? 'Sí' : 'No'}</span>,
    },
    {
      title: 'Número de unidades de la expresión mínima del producto',
      dataIndex: 'units', // Field that is goint to be rendered
      key: 'units',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Precio sugerido',
      dataIndex: 'price', // Field that is goint to be rendered
      key: 'price',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Nombre de Cadena(s)',
      dataIndex: 'all_chains', // Field that is goint to be rendered
      key: 'all_chains',
      render: text => <span>{text}</span>,
    },    
  ]

  const loadData = async () => {
    setVisible(false)
    setVisibleAssign(false)
    setLoading(true)
    try {
      const response = await presentationSrc.getPresentations('', 5, true, 'desc')
      const responseDiscounts = await Discounts.getAllDiscounts()
      setDataDiscounts(getDiscountsData(responseDiscounts))
      setDataSource(getPresentationData(response))

      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    } catch (error) {
      console.log(error)
      message.error('No se ha podido cargar la información')
    }
  }

  const getPresentationData = dataSrc => {
    if (dataSrc !== 'Too Many Attempts.') {
      let _dataSrc = dataSrc?.data?.data || []
      
      return _dataSrc.map((d, i) => ({
        key: i,
        id: d.id,
        company_id: d.company_id,
        description: d.description,
        product_id: d.product !== null && d.product.id !== undefined ? d.product_id : null,
        product_name: d.product !== null ? d.product.description : null,
        price: d.price,
        is_grouping: d.is_grouping,
        units: d.units,
        discount_presentation: d.discount_presentation,
        currency: d.company?.currency?.name ? d.company.currency.name : '',
        all_chains: d.product.store_chains.length > 0 ? d.product.store_chains.map(c => (c.name !== null ? c.name : '')).join(', ') : 0,
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const searchText = async (value) => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(value)
    presentationSrc.getPresentations(value, 5, excludeChars, 'desc').then(response => {
      setDataSource(getPresentationData(response))
      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    })
  }

  const EditRow = data => {
    setEditDataDrawer(data)
    setEditMode(true)
    setVisible(true)
  }

  const DeleteRow = data => {
    setLoading(true)
    presentationSrc
      .removePresentations(data.id)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success(`${res.description} se ha elminado.`)
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al eliminar elemento.')
      })
  }

  const handlerShowDrawer = () => {
    setVisible(true)
    setEditMode(false)
  }

  const moreInfo = () => {
    if (existMoreInfo) {
      setLoading(true)
      Utils.getNextPage(nextPage)
        .then(response => {
          setDataSource(dataSource.concat(getPresentationData(response)))
          setNextPage(response.data.next_page_url)
          setExistMoreInfo(response.data.next_page_url !== null)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar la información')
        })
    }
  }

  const onClose = () => {
    setVisible(false)
  }

  const onSaveButton = (method, data, id) => {
    setLoading(true)
    switch (method) {
      case true:
        presentationSrc
          .editPresentations(id, data)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
              setLoading(false)
            } else {
              message.success('Informacion actualizada.')
              setVisibleAssign(false)
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al actualizar la información.')
          })
        break
      case false:
        presentationSrc
          .newPresentations(data)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
              setLoading(false)
            } else {
              message.success('Informacion creada.')
              setVisibleAssign(false)
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al crear la información.')
          })
        break
      default:
        break
    }
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'price':
          message.error(res.errors[key][0].replace('price', 'Precio'))
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const handlerAssignRow = data => {
    setVisibleAssign(true)
    setAssignData(data)
  }

  return (
    <>
      <GeneralTable
        columns={columns}
        dataSource={dataSource}
        handlerTextSearch={searchText}
        handlerEditRow={EditRow}
        handlerDeleteRow={DeleteRow}
        handlerShowDrawer={handlerShowDrawer}
        loading={loading}
        create={auth.company?.allow_add_products}
        createPermissions={22}
        editPermissions={23}
        deletePermissions={24}
        assign={true}
        handlerAssignRow={handlerAssignRow}
      />
      <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
      <PresentationDrawer
        closable={onClose}
        visible={visible}
        edit={editMode}
        editData={editDataDrawer}
        cancelButton={onClose}
        saveButton={onSaveButton}
        dataDiscounts={dataDiscounts}
        loading={loading}
      />
      <PresentationAssignDrawer closable={() => setVisibleAssign(false)} visible={visibleAssign} cancelButton={onClose} data={assignData} />
    </>
  )
}

export default PresentationTab
